'use client'

import type { ReactNode } from 'react'

import ArrowIcon from '@/assets/icons/arrow.svg'
import ModalCloseIcon from '@/assets/icons/modal-close.svg'

import S from './ModalHeader.module.scss'

export interface ModalHeaderProps {
  title: string
  subtitle?: string
  onBack?: () => void
  onClose: () => void
  titleBottomSpacing?: 'default' | 'none'
  titleClassName?: string
  /** Between back and close, e.g. the picked role (Figma sign-up). */
  center?: ReactNode
}

const ModalHeader = ({
  title,
  subtitle,
  onBack,
  onClose,
  titleBottomSpacing = 'default',
  titleClassName,
  center
}: ModalHeaderProps) => (
  <div className={S.modalHeader}>
    <div className={S.controlsRow}>
      {onBack ? (
        <button
          type="button"
          className={S.backButton}
          onClick={onBack}
          aria-label="Go back"
        >
          <ArrowIcon className={S.backIcon} />
        </button>
      ) : (
        <div className={S.spacer} />
      )}

      {center}

      <button
        type="button"
        className={S.closeButton}
        onClick={onClose}
        aria-label="Close"
      >
        <ModalCloseIcon className={S.closeIcon} />
      </button>
    </div>

    <div
      className={`${S.titleContainer} ${
        titleBottomSpacing === 'none' ? S.titleContainerNoBottom : ''
      }`}
    >
      <h2 className={titleClassName ? `${S.title} ${titleClassName}` : S.title}>
        {title}
      </h2>
      {subtitle && <p className={S.subtitle}>{subtitle}</p>}
    </div>
  </div>
)

export default ModalHeader
